import React from 'react'
import styled from '@emotion/styled';

interface ErrorComponentProps {
    transLoading: string;
    onRetryToipTransCallback: () => void;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ transLoading, onRetryToipTransCallback }) => (
    <Wrapper>
        <img
            src="https://static.toiimg.com/photo/97721339.cms"
            width="62"
            height="62"
            alt=""
        />
        {transLoading !== 'ERROR' && (
            <InfoText>
                Oops, something went wrong, please check again after sometime
            </InfoText>
        )}
        {transLoading === 'ERROR' && (
            <div>
                <InfoText>
                    Oops, something went wrong, please try again
                </InfoText>
                <RetryButton
                    onClick={e => {
                        e.preventDefault();
                        onRetryToipTransCallback();
                    }}
                >
                    Retry Now
                </RetryButton>
            </div>
        )}
    </Wrapper>
);

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    width: 500px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    min-height: 170px;
    text-align: center;

    @media (max-width: 768px) {
        width: 300px;
    }
`;

const InfoText = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: #000;
    font-weight: 400;
    padding: 16px 0 22px;
`;

const RetryButton = styled.button`
    background: #e21b22;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    border-radius: 8px;
    color: #fff;
    border: 0;
    padding: 8px;
    cursor: pointer;
    width: 100%;
    max-width: 328px;
    text-transform: uppercase;
`;

export default ErrorComponent;
